import React from 'react';
import { makeStyles, Paper } from '@material-ui/core';

import Description from 'components/typography/Description';

const useStyles = makeStyles({
  primaryRoot: {
    display: 'flex',
    alignItems: 'center',
    padding: 16,
  },
  ingredientSpace: {
    flexGrow: 1,
  },
  secondaryRoot: {
    display: 'flex',
    justifyContent: 'flex-end',
  },
});

const IngredientsCard = ({
  ingredientUIModel,
  renderButtons,
  isDraggingOver = false,
}) => {
  const classes = useStyles();

  return (
    <Paper elevation={isDraggingOver ? 8 : 4}>
      <div className={classes.primaryRoot}>
        <div className={classes.ingredientSpace}>
          <Description>{ingredientUIModel.ingredientText}</Description>
        </div>
        {renderButtons && renderButtons()}
      </div>
    </Paper>
  );
};

export default IngredientsCard;
